export const MuiIconButton = {
  root: {
    padding: 8
  }
}
